// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2x-ds","footer":"ModalInfo_footer__3FjFk"};